import { i18n } from '../../shared/i18n'
import { logger } from '../logger'
import { readEnv } from '../runtime-env'

const APPLE_AUTH_SCRIPT_URL =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'

let scriptLoaded = false

function loadAppleScript(): Promise<void> {
  if (scriptLoaded) {
    return Promise.resolve()
  }

  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${APPLE_AUTH_SCRIPT_URL}"]`)) {
      scriptLoaded = true
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = APPLE_AUTH_SCRIPT_URL
    script.async = true
    script.onload = () => {
      scriptLoaded = true
      resolve()
    }
    script.onerror = () => reject(new Error(i18n.t('common.errors.sdkLoadFailed')))
    document.head.appendChild(script)
  })
}

export async function signInWithApple(): Promise<string> {
  const clientId = readEnv('VITE_APPLE_CLIENT_ID')

  if (!clientId) {
    throw new Error(i18n.t('common.errors.authConfigError'))
  }

  await loadAppleScript()

  try {
    // redirectURI must be registered in Apple Developer Console under the Service ID configuration
    AppleID.auth.init({
      clientId,
      scope: 'name email',
      redirectURI: `${window.location.origin}/login`,
      usePopup: true,
    })

    const response = await AppleID.auth.signIn()

    if (!response.authorization?.id_token) {
      throw new Error(i18n.t('common.errors.socialSignInFailed'))
    }

    return response.authorization.id_token
  } catch (error_) {
    logger.error('[AppleAuth] Sign-in error:', error_)
    throw error_ instanceof Error ? error_ : new Error(String(error_))
  }
}
